import { Controller } from "@hotwired/stimulus";

// Tiny submit-busy indicator for the playground history "Load more" button.
// On turbo:submit-start it swaps the chevron + label for a spinner and
// disables the button. The server response replaces this whole partial, so
// there's no submit-end path to handle — the new HTML brings its own state.
export default class extends Controller<HTMLFormElement> {
  static targets = ["label", "spinner", "button"];

  declare readonly labelTarget: HTMLElement;
  declare readonly spinnerTarget: HTMLElement;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly hasButtonTarget: boolean;

  busy(): void {
    this.labelTarget.classList.add("hidden");
    this.spinnerTarget.classList.remove("hidden");
    if (this.hasButtonTarget) this.buttonTarget.disabled = true;
  }
}
